import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { FaGithub, FaTwitter, FaLinkedinIn, FaReact, FaJs, FaTwitch, FaInstagram } from "react-icons/fa";
import { SiHtml5, SiCss3 } from "react-icons/si";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ["Frontend Developer.", "Gamer/Streamer.", "Tech Enthusiast."],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">Hello Everyone,</h4>
        <h1 className="text-6xl font-bold text-white">
          I'm <span className="text-designColor capitalize" text-border>Sahil Aherwar</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          a <span className="text-aniColor">{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#FF6969"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">

        </p>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            Socials
          </h2>
          <div className="flex gap-4">
            <span className="bannerIcon">
            <a href='https://www.instagram.com/im_smiley_xb/'><FaInstagram /></a>
            </span>
            <span className="bannerIcon">
              <a href='https://x.com/aherwar_sahil?t=51L1vdaR83a_M5GCzs7cFw&s=09'><FaTwitter /></a>
            </span>
            <span className="bannerIcon">
              <a href='https://www.linkedin.com/in/sahil-aherwar/'><FaLinkedinIn /></a>
            </span>
          </div>
        </div>
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            Highlighted Skills
          </h2>
          <div className="flex gap-4">
            <span className="bannerIcon">
              <SiHtml5 />
            </span>
            <span className="bannerIcon">
              <SiCss3 />
            </span>
            <span className="bannerIcon">
              <FaJs />
            </span>
            <span className="bannerIcon">
              <FaReact />
            </span>
          </div>
        </div>
      </div>
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          Works and Others
        </h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
          <a href='https://github.com/sahilaherwar'><FaGithub /></a>
          </span>
          <span className="bannerIcon">
          <a href='https://www.twitch.tv/mcsmileyy'><FaTwitch /></a>
          </span>
        </div>
      </div>
    </div>
  );
}

export default LeftBanner